export default "__VITE_ASSET__GbNl3fez__"